import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { config } from '../../../config/index';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class CartService {
    constructor(
        private _basewebservice: BaseWebService
    ) {
    }

    addCard(tokenData: any) {
        const data: any = {};
        data.body = tokenData;
        return this._basewebservice.request("v1/payments/payment-methods/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    pay(subscriptionData: any) {
        const data: any = {};
        data.body = subscriptionData;
        return this._basewebservice.request("v1/subscription/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    //get cart details
    getCartDetails() {
        return this._basewebservice.request("v1/cart_details/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
    }

    /** Service docusign **/
    proceedToDocusign = (data: any) => {
        let reqData: any = {};
        data.origin = location.origin + config.publicPath;
        reqData.body = data;
        return this._basewebservice.request("v1/docusign_contract/", "post", reqData)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}